import { render, staticRenderFns } from "./BtnAtualizarAplicacao.vue?vue&type=template&id=1927995d&"
import script from "./BtnAtualizarAplicacao.vue?vue&type=script&lang=js&"
export * from "./BtnAtualizarAplicacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports